import React, { Component } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { connect } from "react-redux";
import LPRouter from "./routes2";
// import "antd/dist/antd.css";
import LandingPage from "./containers/LandingPage";

class App extends Component {

  render() {
    return (
      <Router>
          <LandingPage key="landing" {...this.props}>
            <LPRouter />
          </LandingPage>
      </Router>
    );
  }
}


export default App;
